import type { SiteLayout } from "@/types";
import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getSelectedLayout = async (
  token: string,
  baseUrl: string,
  config?: object
): Promise<SiteLayout> => {
  const queryPath = `${baseUrl}/layouts/selected`;
  const res = await getData(token, queryPath, {}, config);

  return (await deserialize(res.data)) as SiteLayout;
};
